import React from 'react';

const Error = ({ error }) => {
    return (
        <div>{error}</div>
    );
};

export default Error;